import { DbSortOrder } from "src/models/common/TPESearchRequest";
import DASHBOARD_CONSTANTS from "../dashboardConstants";
import { OpenApprovalsSearchRequest } from "src/models/dashboard/OpenApproval";

export function getTopOpenApprovalsSearchPayload(): OpenApprovalsSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.SMALL_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_APPROVAL_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING,
        status: DASHBOARD_CONSTANTS.ACTIVE_STATUS
    };
}

export function getAllApprovalsSearchPayload(): OpenApprovalsSearchRequest {
    return {
        page: 1,
        pageSize: DASHBOARD_CONSTANTS.DEFAULT_PAGE_SIZE,
        sortField: DASHBOARD_CONSTANTS.OPEN_APPROVAL_FIELDS.DUE_DATE.DB_FIELD,
        sortOrder: DbSortOrder.ASCENDING
    };
}